import { Container, Row, Col } from "react-bootstrap";
import ShopAdds from "../../../components/shopAds/ShopAdds";
import Businessprofiletitle from "../../../components/BusinessProfile/Component/Title/businessprofiletitle";
import Rawmaterialcard from "../../../components/BusinessProfile/Component/Rawmaterialcard/Rawmaterialcard";
import Timeline from "../../../components/Timeline/timeline";
import { useParams } from "react-router-dom";
import BackArrow from "../../../components/backArrow";
const ServiceBusinessProfile = () => {
  const { id } = useParams();
  return (
    <>
      <Container>
        <Row className="align-items-start">
          <Col lg="7" className="screenHeight p-0">
            <div className="border b-radius">
              <div className="ms-2"><BackArrow /></div>
              
              <ShopAdds />
              <Businessprofiletitle
                name="Services"
                navigate="/services-profile"
                linkurl="/services-profile"
                id={id}
              />
              <Rawmaterialcard />
            </div>
          </Col>

          <Col
            lg="5"
            sm="12"
            className="ps-4 screenHeight"
            style={{ position: "relative" }}
          >
            <div className="border b-radius">
              <Timeline />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ServiceBusinessProfile;
